/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#descriptionField[_ngcontent-%COMP%], #titleField[_ngcontent-%COMP%], #websiteField[_ngcontent-%COMP%]{width:90%}"];
export { styles as styles };
